import { render } from "./CasesBox.vue?vue&type=template&id=e3b8ffb2&scoped=true"
import script from "./CasesBox.vue?vue&type=script&lang=js"
export * from "./CasesBox.vue?vue&type=script&lang=js"

import "./CasesBox.vue?vue&type=style&index=0&id=e3b8ffb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3b8ffb2"]])

export default __exports__